/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
}); 


jQuery( document ).ready(function() {
    
    jQuery(".partner-slider").slick({

      // normal options...
      infinite: true,
      slidesToShow: 4,
      autoplay: true,
		autoplaySpeed: 2000,
		lazyLoad: 'ondemand',
		arrows: false,

      // the magic
      responsive: [{

          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }

        }, {

          breakpoint: 600,
          settings: {
            slidesToShow: 2,
          }

        }],
    });

    jQuery(".materials-slider").slick({

      // normal options...
      infinite: true,
      slidesToShow: 3,
        autoplay: true,
			autoplaySpeed: 3000,
			asNavFor: '.slider-nav,.materials-slider',
			arrows: false,
			dots: false,
			lazyLoad: 'ondemand',

      // the magic
      responsive: [{

          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }

        }, {

          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          }

        }],
    });

    jQuery(".referenz-slider").slick({

      // normal options...
      infinite: true,
      slidesToShow: 3,
      autoplay: true,
		  autoplaySpeed: 2000,
		  centerMode: true,
		  variableWidth: false,
		  //lazyLoad: 'ondemand',

		  arrows: true,
		  appendArrows: '#referenz-arrows',
		  //prevArrow: 
		  dot: false,

      // the magic
      responsive: [{

          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }

        }, {

          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          }

        }],
    });

    var $grid = jQuery('.grid').masonry({
      // options
      columnWidth: '.grid-sizer',
      itemSelector: '.grid-item',
      percentPosition: true
    });

    // layout Masonry after each image loads
    $grid.imagesLoaded().progress( function() {
      $grid.masonry('layout');
    });


});

jQuery(function(){

	jQuery(window).scroll(function(){   
		if (jQuery(window).scrollTop() >= 150){
			jQuery('.navigation-wrapper.fixed').addClass('slideDown');
		} else {
			jQuery('.navigation-wrapper.fixed').removeClass('slideDown');
		}

		if (jQuery(window).scrollTop() + jQuery(window).height() > (jQuery(document).height() - 100) ){
			jQuery("#fixed-button").addClass("hide-me");
		} else {
			jQuery("#fixed-button").removeClass("hide-me");
		}
	
	});
});

AOS.init({
  // Global settings:
  disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
  startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
  initClassName: 'aos-init', // class applied after initialization
  animatedClassName: 'aos-animate', // class applied on animation
  useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
  disableMutationObserver: false, // disables automatic mutations' detections (advanced)
  debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
  throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
  

  // Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
  offset: 120, // offset (in px) from the original trigger point
  delay: 0, // values from 0 to 3000, with step 50ms
  duration: 800, // values from 0 to 3000, with step 50ms
  easing: 'ease', // default easing for AOS animations
  once: true, // whether animation should happen only once - while scrolling down
  mirror: false, // whether elements should animate out while scrolling past them
  anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});


jQuery('div.ginput_container input, div.ginput_container textarea, div.ginput_container select').each(function() {
	//console.log(jQuery(this));
	jQuery(this).on('focus', function() {
		jQuery(this).parent().parent().addClass('focused');
	});

	jQuery(this).on('blur', function() {
		if (jQuery(this).val().length == 0) {
			jQuery(this).parent().parent().removeClass('focused');
		}
	});

	//if (jQuery(this).val() != '') jQuery(this).parent('.grid').addClass('focused');

});
